export const ROOT = '/'

export const HOME = `${ROOT}`
export const LOGIN = `${ROOT}login`
export const FACM = `${ROOT}facm`
export const FACM_ALL = `${FACM}/all`
export const FACM_ONGOING = `${FACM}/ongoing`
export const FACM_DETAIL = `${FACM}/detail/:id`
export const FACM_PENDING = `${FACM}/pending`
export const FACM_PLANNED = `${FACM}/planned`
export const PROFILE = `${ROOT}profile`
export const USER_LIST = `${ROOT}user`
export const USER_CREATE = `${USER_LIST}/create`
export const USER_EDIT = `${USER_LIST}/edit/:id`
export const CONFIRM_PASSWORD = `${ROOT}confirm-password/:confirmToken`
export const RESET_PASSWORD = `${ROOT}reset-password/:resetToken`
export const CHANGE_EMAIL = `${ROOT}change-email/:changeToken`
export const FORGOT_PASSWORD = `${ROOT}forgot-password`
export const NOTIFICATION = `${ROOT}notifications`
export const NOTIFICATION_LIST = `${NOTIFICATION}/list`
export const NOTIFICATION_PUBLISH = `${NOTIFICATION}/publish`
export const CONTACT = `${ROOT}contact`

export const GRID_LIST = `${ROOT}grid`
export const GRID_EDIT = `${GRID_LIST}/edit/:id`
export const GRID_CREATE = `${GRID_LIST}/create`

export const INTERNSHIP_LIST = `${ROOT}internship`
export const INTERNSHIP_EDIT = `${INTERNSHIP_LIST}/edit/:id`
export const INTERNSHIP_CREATE = `${INTERNSHIP_LIST}/create`

export const EVALUATION_LIST = `${ROOT}evaluation`
export const EVALUATION_SHOW = `${EVALUATION_LIST}/show/:id`

export const NOTIFICATION_SETTINGS = `${ROOT}notification-settings`

export const PATHS = {
  INTERNSHIP_LIST,
  INTERNSHIP_EDIT,
  INTERNSHIP_CREATE,
  EVALUATION_LIST,
  EVALUATION_SHOW,

  GRID_LIST,
  GRID_EDIT,
  GRID_CREATE,
  ROOT,
  CONTACT,
  USER_EDIT,
  PROFILE,
  HOME,
  FORGOT_PASSWORD,
  LOGIN,
  USER_LIST,
  CHANGE_EMAIL,
  USER_CREATE,
  CONFIRM_PASSWORD,
  RESET_PASSWORD,
  FACM,
  FACM_ONGOING,
  FACM_ALL,
  FACM_DETAIL,
  FACM_PLANNED,
  FACM_PENDING,
  NOTIFICATION,
  NOTIFICATION_LIST,
  NOTIFICATION_PUBLISH,

  NOTIFICATION_SETTINGS,
}
